export let userObject = {
  _id: ``,
  watchList: [],
  email: ``,
  password: ``,
};
